(function (ws) {
    'use strict';

    ws.models.cartTableAddProductsArray = ws.models.outstandingStock.extend({
        idAttribute: 'partsNo',

        defaults: {
            quantity: '["1","1"]',
            productCode: '["WestconTest1","Westcon"]'
        },

        /**
         * Initialize function
         * @param {Object} options
         */
        initialize: function (options) {
            this.urlRoot = options.apiUrl;
            this.attributes = options.products;
        },

        /**
         * Parsing the response data to template
         * @param {Object} data
         * @returns {Object} data}
         */
        parse: function (data) {

            _.each(data.data, function(data) {
                data.partsNoUrl = encodeURIComponent(data.partsNo);
                data.sapAvailabilityList = data.sapavailabilityList;
                data.maxAvailabilityRows = this.getMaxRowCount(data.sapavailabilityList);
                data.futureAvailabilityCount = this.hasFutureAvailability(data.sapavailabilityList);
                data.isCustomerInventoryCount = this.hasCustomerStock(data.sapavailabilityList);
            }.bind(this));

            return data;
        }
    });
})(westcon);
